/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShieldChevron = createReactComponent("outline", "shield-chevron", "IconShieldChevron", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M4 14l8 -3l8 3", "key": "svg-1" }]]);

export { IconShieldChevron as default };
//# sourceMappingURL=IconShieldChevron.mjs.map
